// components/MidnightLogout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearSession } from '../utils/clearSession';

const MidnightLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0); // 12:00 AM
    const msUntilMidnight = midnight.getTime() - now.getTime();

    const timeout = setTimeout(() => {
      clearSession();
      sessionStorage.clear(); // optional
      navigate('/');
    }, msUntilMidnight);

    return () => clearTimeout(timeout); // cleanup
  }, [navigate]);

  return null;
};

export default MidnightLogout;
